import React from "react";
import useRequest from "../../../Utils/useRequest";
import { getSysMessage, setSingleRead, SysMessage } from "../../../API";
import { RouteComponentProps } from "react-router-dom";
import { Spin } from "antd";
import { useHeaderProps } from "../../../components/Layouts/SubLayout/useHeaderProps";
import styles from "./index.module.scss";
import moment from "moment/moment";

export default function SystemMsgDetail({
    match
}: RouteComponentProps<{ id: string }>) {
    const [data, { loading }] = useRequest(
        async (): Promise<SysMessage | undefined> => {
            const list = await getSysMessage();
            await setSingleRead(match.params.id);

            return list?.find(
                item => String(item.id) === String(match.params.id)
            );
        },
        {},
        [match.params.id]
    );

    useHeaderProps({ title: "通知详情" });

    return (
        <div className={styles.root}>
            <Spin spinning={loading}>
                <h1 className={styles.title}>{data?.title}</h1>

                <div className={styles.time}>
                    {moment(data?.createTime).format("YYYY-MM-DD HH:mm")}
                </div>

                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: data?.content || "" }}
                />
            </Spin>
        </div>
    );
}
